export const binarySearchInsert = <T>(arr: T[], val: T): void => {
	let low = 0;
	let high = arr.length;
	while (low < high) {
		const i = Math.floor((low + high) / 2);
		if (arr[i] < val) low = i + 1;
		else high = i;
	}
	arr.splice(low, 0, val);
};

export const binarySearchRemove = <T>(arr: T[], val: T): void => {
	let low = 0;
	let high = arr.length;
	while (low < high) {
		const i = Math.floor((low + high) / 2);
		if (arr[i] < val) low = i + 1;
		else if (arr[i] > val) high = i;
		else arr.splice(i, 1);
	}
};

export const delay = async (ms: number): Promise<void> => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const download = (file: File): void => {
	// setup
	const url = URL.createObjectURL(file);
	const a = document.createElement("a");
	a.href = url;
	a.download = file.name;

	// download
	document.body.appendChild(a);
	a.click();

	// cleanup
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
};

export const formatDataAmount = (amount: number): string => {
	const units = ["B", "KB", "MB", "GB"];

	let i = 0;
	for (; amount > 999; amount /= 1e3) i++;

	return `${parseFloat(amount.toFixed(2))} ${units[i]}`;
};
